export default __webpack_public_path__ + "d85b5b32e5f7bdf3ecd0c2075cc8a55a.svg";